module.exports = __webpack_public_path__ + "bg.423461878ce8cfcc29bc.jpg";


//////////////////
// WEBPACK FOOTER
// D:/My Projects/2023/eCompound/unimas-request-web/src/assets/images/bg.jpg
// module id = ../../../../../src/assets/images/bg.jpg
// module chunks = styles